import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useRebelContext = () => {
  const user = useSelector((state) => state.user);

  const [helperContext, setHelperContext] = useState({
    // hasUserConsented: false,
    isUserLoggedIn: false,
    userId: user?.get("id"),
    lang: user?.get("user_preference")?.get("language") ?? "ENG",
  });

  useEffect(() => {
    setHelperContext({
      isUserLoggedIn: user.get("jwt"),
      userId: user.get("id"),
      lang: user?.get("user_preference")?.get("language") ?? "ENG",
    });
  }, [user]);
  return helperContext;
};

export default useRebelContext;
